module.exports = __webpack_public_path__ + "img/abdomen.ca1fd6c6.svg";